define('booking', function(require) {
    'use strict';

    // require('bootstrap/transition');
    // require('bootstrap/carousel');

    require('bootstrap');

});